import React from 'react'
import type { SingleValue } from 'react-select'
import { IKReactSelect } from '../../../ui-kit'

import { getFieldsMapping, operatorsMapping } from '../../../utils/mediaLibrary'
import type { CustomMetadataResponse, SearchFilterJson } from '../../interfaces'

interface Props {
  expression: SearchFilterJson
  customMetadataField?: CustomMetadataResponse
  width?: string
  handleOperatorChange(operator: string): void
}

const OperatorMenu = (props: Props): React.ReactElement => {
  const { expression, customMetadataField, handleOperatorChange } = props
  const fieldMapping = getFieldsMapping({
    fieldName: expression.fieldName,
    customMetadataField,
  }).possibleOperators?.map(val => ({
    label: operatorsMapping[val].text,
    value: val,
  }))

  return (
    <IKReactSelect
      menuPlacement='auto'
      variant="compact"
      placeholder="Select operator"
      isSearchable={false}
      options={fieldMapping}
      value={
        expression.operator
          ? {
              label: operatorsMapping[expression.operator].text,
              value: expression.value as string,
            }
          : fieldMapping
          ? fieldMapping[0]
          : null
      }
      onChange={(
        newVal: SingleValue<{
          label: string
          value: string
        }>,
      ) => {
        newVal?.value && handleOperatorChange(newVal.value)
      }}
    />
  )
}

export default OperatorMenu
